/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import allLocales from "@fullcalendar/core/locales-all";
// import interactionPlugin from "@fullcalendar/interaction";
// import momentPlugin from "@fullcalendar/moment";
// import { allLocales } from "@fullcalendar/core";

import { getCalendar, showModal, getTrainingDetail } from "actions";

import "components/calendar/Calendar.css";
import { connect } from "react-redux";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import SuggestedTrainings from "./SuggestedTrainings";
import { Trans } from "react-i18next";
import i18next from "i18next";
import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";

class ManagerCalendar extends Component {
  date = new Date();
  // var d = date.getDate();
  m = 0;
  y = this.date.getFullYear();

  state = {
    calendarFetched: false,
    calendarWeekends: true,
    selectedTrainingDetail: null,
    searchTerm: ""
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) { }

  onFetchBegin = () => {
    this.props.onProcessBegin();
  };

  onFetchError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onFetchSuccess = () => {
    this.props.onProcessEnd();
    this.setState({ calendarFetched: true });

    // console.log(this.props);
  };

  fetchData = () => {
    const d1 = new Date();
    d1.setMonth(d1.getMonth() - 2); //2 ay öncesi

    const d2 = new Date();
    d2.setMonth(d2.getMonth() + 19); //18 ay sonrasına gidip 1 ay geri gidilerek ayın son gününe gidiliyor
    d2.setDate(d2.getDate() - d2.getDate());

    this.props.getCalendar(
      `${d1.getFullYear()}-${d1.getMonth() + 1}-01`,
      `${d2.getFullYear()}-${d2.getMonth() + 1}-${d2.getDate()}`,
      this.onFetchBegin,
      this.onFetchSuccess,
      this.onFetchError
    );
  };

  handleEventSelected = (training, isParent, timeplanId, startDate) => {
    this.openTrainingDetailModal({
      training: training,
      isParent: isParent,
      timeplanId: timeplanId,
      startDate: startDate,
    });
  };

  openTrainingDetailModal = (training) => {
    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: "",
      modalContent: <TrainingDetailModal training={training} />,
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  getColor = (eventType) => {
    // console.log(eventType);
    switch (eventType) {
      case "ApprovedTraining":
        return "#a413a9";
      case "ApprovalTraining":
        return "#8197b5";
      case "TargetPosition":
        return "#04306b";
      case "QuotaAvaible":
        return "#09b409";
      case "CompanyQuotaFull":
        return "#ff940a";
      case "QuotaFull":
        return "#e12f40";
      default:
        return "#2d96cd";
    }
  };

  renderCalendar = () => {
    if (!this.state.calendarFetched) return null;
    return (
      <FullCalendar
        // defaultView="dayGridMonth"
        header={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,dayGridWeek,dayGridDay",
        }}
        buttonIcons={{
          prev: "left-single-arrow",
          next: "right-single-arrow",
          prevYear: "left-double-arrow",
          nextYear: "right-double-arrow",
        }}
        locales={allLocales}
        locale={localStorage.getItem("i18nextLng")}
        plugins={[
          dayGridPlugin,
          // // timeGridPlugin,
          // interactionPlugin,
          //   momentPlugin,
        ]}
        bootstrapFontAwesome={true}
        ref={this.calendarComponentRef}
        weekends={this.state.calendarWeekends}
        events={this.props.calendar.map((ev) => {
          return {
            id: ev.training.id,
            title: ev.training.name,
            start: ev.startDate,
            end: ev.endDate,
            color: this.getColor(ev.type),
            isParent: ev.isParent,
            timeplanId: ev.recordId,
            training: ev.training,
            startDate: ev.startDate,
          };
        })}
        dateClick={(e) => this.handleDateClick(e)}
        contentHeight="600"
        displayEventTime={false}
        disableDragging={true}
        editable={false}
        eventLimit={true}
        droppable={false}
        // eventRender={function (event, element) {
        //   if (event.icon) {
        //     if (event.iconposition === 0) {
        //       element
        //         .find(".fc-title")
        //         .prepend(
        //           '<div className="tooltipTakvim w-auto" data-html="true" data-toggle="tooltip" data-placement="bottom" title="' +
        //             event.tooltipText +
        //             '"><span className="icon-icon-' +
        //             event.icon +
        //             ' mr-1"></span></div>'
        //         );
        //     } else {
        //       element
        //         .find(".fc-title")
        //         .append(
        //           '<span className="icon-icon-' + event.icon + ' ml-1"></span>'
        //         );
        //     }
        //   }
        // }
        // }
        eventMouseEnter={function (event, element) {
          //console.log(event.event.id, event.event.title, event.event.start, event.event.end)
        }}
        eventClick={(event) => {
          this.handleEventSelected(
            event.event.extendedProps.training,
            event.event.extendedProps.isParent,
            event.event.extendedProps.timeplanId,
            event.event.extendedProps.startDate
          );
        }}
      />
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        <div className="container">
          <div className="row py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 px-4 d-none d-sm-none d-md-flex d-lg-flex">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/">
                    <span className="icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Eğitim Takvimi">10034</Trans>
                </li>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4 d-flex d-sm-flex d-md-none d-lg-none">
              <div className="sssBaslik">
                <Trans desc="Eğitim Takvimi">10034</Trans>
              </div>
            </div>
            {/* <div className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2">
              <div className="tamamlananEgitimAlani tumDepartmanlar calendarTopChartArea">
                <div
                  id="calendarTopChart_1"
                  className="chartGraphic"
                  data-percent1="94"
                  data-percent2="33"
                ></div>
                <div className="egitimSayisi satisDepTak td">
                  <div className="satisSonrasiOrani tekdeger satisDepOrt">
                    <sup>%</sup>33
                  </div>
                  <ul className="infoTextCalendar">
                    <li>Satış Departmanı Ortalaması</li>
                    <li>Eğitim Tamamlanma Oranı</li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
          <div className="row py-lg-4 py-md-4 py-sm-2 py-2 px-2 bottomRow">
            <div className="col-xl-3 col-lg-4 col-md-4 p-0">
              <div className="row mb-1">
                {/* <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 pr-xl-1 py-xl-0 pr-lg-1 py-lg-0 pr-md-1 py-md-0 p-sm-2 py-sm-0 px-2 pb-2">
                  <div className="inner-addon right-addon">
                    <select
                      className="custom-select"
                      id="egitimDurumu"
                      // onchange="listCategory()"
                    >
                      <option value="1">Önerilen Eğitimler</option>
                      <option value="all">Tümünü Göster</option>
                    </select>
                  </div>
                </div> */}
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-xl-1 py-xl-0 pl-lg-1 py-lg-0 pl-md-1 py-md-0 p-sm-2 py-sm-0 px-2 py-0">
                  <div className="inner-addon right-addon">
                    <span className="iconmford fo-icon-search"></span>
                    <input
                      type="text"
                      name="egitimBul"
                      id="egitimBul"
                      className="form-control"
                      placeholder={i18next.t("10053")}
                      onChange={(e) => this.setState({ searchTerm: e.target.value })}
                    />
                  </div>
                </div>
              </div>
              <SuggestedTrainings searchTerm={this.state.searchTerm} />
            </div>

            <div className="col-xl-9 col-lg-8 col-md-8 p-0">
              <div className="row">
                <div
                  id="calendar"
                  className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                >
                  {this.props.spinner}
                  {this.renderCalendar()}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 mt-3">
                  <ul className="calendarBottomMenu">
                    <li className="legend-green"><Trans desc="Kontenjan Uygun">10540</Trans></li>
                    <li className="legend-orange"><Trans desc="Bayi Kontenjanı Dolu">10541</Trans></li>
                    <li className="legend-red"><Trans desc="Eğitim Kontenjanı Dolu">10542</Trans></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    calendar: state.calendar.data.calendarItems,
  };
};

export default connect(mapStateToProps, {
  getCalendar,
  showModal,
  getTrainingDetail,
})(requireAuth(containsLongRunningProcess(ManagerCalendar)));
